<template>
  <div class="h-100 background">
    <Navbar></Navbar>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar'
export default {
  name: "AppHome",
  components: {
    Navbar,
  }
}
</script>

<style scoped>

</style>